export default __webpack_public_path__ + "static/media/graca1.d77a2f83.png";